(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .factory('NotificationPreferenceService', NotificationPreferenceService);

    NotificationPreferenceService.$inject = ['$http'];

    function NotificationPreferenceService($http) {
        var service = {
            getPreferences: getPreferences,
            updatePreferences: updatePreferences,
            updateSinglePreference: updateSinglePreference
        };

        return service;

        function getPreferences() {
            return $http.get('/api/notification-preferences')
                .then(function(response) {
                    return response.data;
                });
        }

        function updatePreferences(preferences) {
            return $http.put('/api/notification-preferences', preferences);
        }

        function updateSinglePreference(typeKey, enabled) {
            return $http.put('/api/notification-preferences/' + typeKey + '?enabled=' + enabled);
        }
    }
})();

